/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Product_RequiredInputs */

const en_cargo_product_required = /** @type {(inputs: Cargo_Product_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product is required`)
};

const es_cargo_product_required = /** @type {(inputs: Cargo_Product_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El producto es obligatorio`)
};

/**
* | output |
* | --- |
* | "Product is required" |
*
* @param {Cargo_Product_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_product_required = /** @type {((inputs?: Cargo_Product_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Product_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_product_required(inputs)
	return es_cargo_product_required(inputs)
});